import { ModuleWithProviders, NgModule, Provider } from '@angular/core';
import { AnswerTemplateGateway, ListAnswerTemplateUseCase } from './domain';
import { HttpClient } from '@angular/common/http';
import { AnswerTemplatesBffGateway } from './infra';
import { BASE_URL } from './infra';
import { AnswerTemplateListComponent } from './feature/answer-templates/components/answer-template-list/answer-template-list.component';
import { TranslateModule } from '@ngx-translate/core';
import { AsksuiteCitrusModule } from 'asksuite-citrus';
import { CommonModule } from '@angular/common';
import { AnswerTemplatesFacade } from './feature/answer-templates/services/answer-templates.facade';
import {
  CdkFixedSizeVirtualScroll,
  CdkVirtualForOf,
  CdkVirtualScrollViewport,
} from '@angular/cdk/scrolling';
import { AnswerTemplateManageModalComponent } from './feature/answer-templates/components/answer-template-manage-modal/answer-template-manage-modal.component';
import { ReactiveFormsModule } from '@angular/forms';
import { CreateAnswerTemplateUseCase } from './domain/use-cases/create-answer-template-use.case';
import { AnswerTemplateManageModalFacade } from './feature/answer-templates/services/answer-template-manage-modal.facade';
import { UpdateAnswerTemplateUseCase } from './domain/use-cases/update-answer-template-use.case';
import { AnswerTemplateDeleteModalComponent } from './feature/answer-templates/components/answer-template-delete-modal/answer-template-delete-modal.component';
import { DeleteAnswerTemplateUseCase } from './domain/use-cases/delete-answer-template-use.case';
import { SharedModule } from 'src/app/shared/shared.module';

const listTemplatesUseCase = (answerTemplateRepo: AnswerTemplateGateway) =>
  new ListAnswerTemplateUseCase(answerTemplateRepo);
const listTemplatesProvider = {
  provide: ListAnswerTemplateUseCase,
  factory: listTemplatesUseCase,
  deps: [AnswerTemplateGateway],
};

const createTemplatesUseCase = (answerTemplateRepo: AnswerTemplateGateway) =>
  new CreateAnswerTemplateUseCase(answerTemplateRepo);
const createTemplatesProvider = {
  provide: CreateAnswerTemplateUseCase,
  factory: createTemplatesUseCase,
  deps: [AnswerTemplateGateway],
};

const updateTemplatesUseCase = (answerTemplateRepo: AnswerTemplateGateway) =>
  new UpdateAnswerTemplateUseCase(answerTemplateRepo);
const updateTemplatesProvider = {
  provide: UpdateAnswerTemplateUseCase,
  factory: updateTemplatesUseCase,
  deps: [AnswerTemplateGateway],
};

const deleteTemplatesUseCase = (answerTemplateRepo: AnswerTemplateGateway) =>
  new DeleteAnswerTemplateUseCase(answerTemplateRepo);
const deleteTemplatesProvider = {
  provide: DeleteAnswerTemplateUseCase,
  factory: deleteTemplatesUseCase,
  deps: [AnswerTemplateGateway],
};

@NgModule({
  providers: [
    {
      provide: AnswerTemplateGateway,
      useFactory: (httpClient: HttpClient, baseBffUrl: string) => {
        return new AnswerTemplatesBffGateway(httpClient, baseBffUrl);
      },
      deps: [HttpClient, BASE_URL],
    },
    listTemplatesProvider,
    createTemplatesProvider,
    updateTemplatesProvider,
    deleteTemplatesProvider,
    AnswerTemplatesFacade,
    AnswerTemplateManageModalFacade,
  ],
  exports: [AnswerTemplateListComponent, AnswerTemplateManageModalComponent],
  imports: [
    TranslateModule,
    AsksuiteCitrusModule,
    CommonModule,
    CdkVirtualScrollViewport,
    CdkVirtualForOf,
    CdkFixedSizeVirtualScroll,
    ReactiveFormsModule,
    SharedModule,
  ],
  declarations: [
    AnswerTemplateListComponent,
    AnswerTemplateManageModalComponent,
    AnswerTemplateDeleteModalComponent
  ],
})
export class AnswerTemplateModule {
  static forRoot(params: {
    baseBffUrl: string;
    translator: Provider;
    companyService: Provider;
    userService: Provider;
  }): ModuleWithProviders<AnswerTemplateModule> {
    return {
      ngModule: AnswerTemplateModule,
      providers: [
        {
          provide: BASE_URL,
          useValue: params.baseBffUrl,
        },
        params.translator,
        params.companyService,
        params.userService,
      ],
    };
  }
}
